
/*------------------------------------------------------------------
  - This sccript for adding product variants for seller to sell his item
-------------------------------------------------------------------*/


$( document ).ready(function() {

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }
  
  
  //Opening modal window
  //Opening modal window on click of button
  $('.update_variant_btn').click(function (){
    $('.product_variants_option_2').dropdown({allowAdditions: true});
    var updateVariantPopup = $('.update-variants-modal');
  	updateVariantPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      zIndex: 4,
      closeClass: 'modal__close'
    });
  });
  
  //Removing product variant through server
  $(document).on('click', '#delete-variant', function(e){ 
    var emailId = readCookie('seller_email');
    var sessionId = readCookie('session_token');
    var productId = $(this).attr("data-product");
    var variantId = $(this).attr("data-variant");
    var imageId = $(this).attr("data-imageId");
   	var removeTr = $(this).parents('tr');
    var token = readCookie('token');
   	 $(".loding_container").show();
   
   	var updateVariantBtn = $('#update_variant_button');
      updateVariantBtn.attr("disabled", true);  
    
    e.preventDefault();
    $.ajax({ 
      type: 'GET', 
      //url: 'https://test-designers.lovethisstuff.com/website/product/deleteVariant', 
      url: 'https://api-test.lovethisstuff.com/v1/products/deleteVariantAPI?token='+token+'',

      data: "shopifyProductId="+productId+"&shopifyVariantId="+variantId+"", 
      dataType: 'json',
      success: function (data) { 
        
        if(data.messageType === "SUCCESS") {
          $(".loding_container").fadeOut();
          updateVariantBtn.attr("disabled", false);
          
          removeTr.remove();
          $('.api_success').fadeOut();
          $('.api_error').fadeOut();
          $('#update_variant_success').html(data.message);
          $('#update_variant_success').fadeIn();
          
          setTimeout(function() {$('div#update_variant_success').css('display','none');},2000);
         
        } else if(data.messageType === "SESSION_EXPIRED") {
          $('.api_error').fadeOut();
          $('#update_variant_error').html(data.message).fadeIn();
        } else if(data.messageType === "FAILURE"){
            $(".loding_container").hide();
          	$('.api_error').fadeOut();
         	$('#update_variant_error').html("Product should have atleast one variant. Last variant of the product can not be deleted").fadeIn();
           updateVariantBtn.attr("disabled", false);
         
          
        }
      },
      error : function (data) {
        
        $(".loding_container").fadeOut();
        updateVariantBtn.attr("disabled", false);
        $('.api_error').fadeOut();
        $('#update_variant_error').html(data.message).fadeIn();
        },
      cache: false,
      contentType: false,
      processData: false
      
    });
    
  });

  
  
    
  //Saving new product data
  $("form#update_variant_form").submit(function(e){
    e.preventDefault();

    var hasError = false;
     $("#variant_tabel_body tr").each(function(i, row){
       var cols = $(row).find("td input:last-child").slice(-4);
       var $col0 = $(cols[0]);
       var $col1 = $(cols[1]);
       if(parseFloat($col0.val()) < parseFloat($col1.val())){
		  	$col0.closest("td").addClass("has-error");
         	$col1.closest("td").addClass("has-error");
         	$col0.focus();
         	hasError = true;
       } else {
            $col0.closest("td").removeClass("has-error");
         	$col1.closest("td").removeClass("has-error");
       }
     });
    
    if(hasError){
      $("#variant_price_error_message").show();
    } else {
      $("#variant_price_error_message").hide();
      $(".loding_container").fadeIn();
      var updateProductSubmitBtn = $('#update_variant_button');  // submit button
      updateProductSubmitBtn.html('Saving...');
      updateProductSubmitBtn.prop('disabled', true); // disable button
      updateProductSubmitBtn.attr("disabled", true); // disable button
      var formData = new FormData($("#update_variant_form")[0]);   
      var token = readCookie('token');


      $.ajax({
      //  url: "https://test-designers.lovethisstuff.com/website/product/updateProductVariant",
       url: 'https://api-test.lovethisstuff.com/v1/products/updatevariantAPI?token='+token+'',
        type: 'POST',
        data: formData,
        processData: false,
        async: true,
        beforeSend: function() {
          updateProductSubmitBtn.html('Saving ...');
          updateProductSubmitBtn.prop('disabled', true); // disable button
          updateProductSubmitBtn.attr('disabled', true); // disable button
        },
        success: function (data) {
          $(".loding_container").fadeOut();
          if(data.messageType === "SUCCESS") {
            updateProductSubmitBtn.html('Saved');
            updateProductSubmitBtn.prop('disabled', true); // disable button
            updateProductSubmitBtn.attr('disabled', true); // disable button
            $('.api_success').fadeOut();
            $('.api_error').fadeOut();
            $('#update_variant_success').html(data.message);
            $('#update_variant_success').fadeIn();
          //  setTimeout(function(){location.reload();},700);
          } else if(data.messageType === "SESSION_EXPIRED" || data.messageType === "UNAPPROVED") {
            updateProductSubmitBtn.html('Submit'); // change submit button text
            updateProductSubmitBtn.attr('disabled', false); // disable button
            $('.api_error').fadeOut();
            $('#update_variant_error').html(data.message).fadeIn();
          }
          
          setTimeout(function(){location.reload();},400);

        },
        error : function (data) {
          $(".loding_container").fadeOut();
          updateProductSubmitBtn.html('Submit'); // change submit button text
          updateProductSubmitBtn.attr("disabled", false); // Enabling button
          updateProductSubmitBtn.prop('disabled', false); // disable button
          $('.api_success').fadeOut();
          $('.api_error').fadeOut();
          $('#update_variant_error').html(data.message).fadeIn();
        },
        cache: false,
        contentType: false,
        processData: false
      });
    }
    
    return false;
  });
  
  
  // Show product details tab
  $('#add_more_variants').click(function (e){
    e.preventDefault();
       var addProductVariantPopup = $('.add-variants-modal');
  		addProductVariantPopup.bPopup({
        positionStyle: 'fixed',
        scrollBar: 'true',
          zIndex: 5,
        closeClass: 'modal__close'
      });
  });
  
});